import { NgModule } from '@angular/core';
import { BrandingDirective } from './components/sidenav/branding.directive';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { TopbarComponent } from './components/topbar/topbar.component';

@NgModule({
  imports: [SidenavComponent, TopbarComponent, BrandingDirective],
  exports: [SidenavComponent, TopbarComponent, BrandingDirective],
})
export class SidenavModule {}
